import {useMemo} from 'react'
import {
  ChatMessage,
  DataObjectId,
  DealActivityItem,
  DealActivityMovedItem,
  Hub
} from 'yougile-model'
import {useChatStore} from '@components/right-panel/chat/chat-store'
import {getDealActivity} from './get-deal-activity'

export const getDealTimeLineMessageData = (hub: Hub): DealActivityItem[] => {
  const movedChatMessages: ChatMessage[] = Array.from(
    hub.chat?.messages?.values() ?? []
  ).filter(m => m.properties?.fromSystem && m.properties?.move)

  const movedMessages: DealActivityMovedItem[] = movedChatMessages.map(m => ({
    id: m.id,
    from: m.from,
    type: 'moved',
    timestamp: m.timestamp,
    moved: {
      from: m.properties?.from as DataObjectId | undefined,
      to: m.properties?.to as DataObjectId | undefined
    }
  }))

  const activity: DealActivityItem[] = getDealActivity(hub) ?? []

  return [...activity, ...movedMessages].sort((a, b) => {
    const aTime = a.type === 'deal' ? a.deadline ?? a.timestamp : a.timestamp
    const bTime = b.type === 'deal' ? b.deadline ?? b.timestamp : b.timestamp
    return aTime - bTime
  })
}

export const useDealTimeLineMessageData = (hub: Hub): DealActivityItem[] => {
  const [, chatStore] = useChatStore()

  const dealTimeline = useMemo(() => {
    return getDealTimeLineMessageData(hub)
  }, [
    hub.chat?.messages,
    hub.data?.dealActivity,
    Object.keys(hub.data?.dealActivity ?? {}).length,
    chatStore.state.messagesList
  ])

  return dealTimeline
}
